module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8478/img/spinner.png"